import { NgModule } from '@angular/core';

import { AmplifyComponent } from './Core/components/Amplify/amplify.component';
import { AmplifyRoutingModule } from './AmplifyRouter/amplify-routing.module';
import { AmplifyCoreModule } from './Core/amplify-core.module';
import { WireModule } from './Wire/wire.module';
import { WireApi } from '../api/wire/wire.api';
import { WireService } from './Wire/services/wire.service';
import { AmplifySharedModule } from './AmplifyShared/amplify-shared.module';


@NgModule({
    imports: [
        AmplifyRoutingModule,
        AmplifyCoreModule,
        AmplifySharedModule,
        WireModule
    ],
    providers: [
        WireApi,
        WireService
    ],
    exports: [
        AmplifyComponent
    ]
})
export class AmplifyModule { }
